module.exports = __webpack_public_path__ + "img/logo_tranciti.e8a9ebd1.svg";